import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import toDollars from 'utils/to-dollars';

// Global Types
import { AppState } from 'services/types';
import {
    MyTimesheetEntryEffectiveRate,
    MyTimesheetEntriesProps
} from 'services/myTimesheetEntries/types';

// Global Selectors
import { makeSelectMyTimesheetEffectiveRate } from 'services/myTimesheetEntries/selectors';

type OwnProps = MyTimesheetEntriesProps;

interface ConnectedProps {
    effectiveRate?: MyTimesheetEntryEffectiveRate;
}

type Props = OwnProps & ConnectedProps;

export class MyTimesheetEntryEffectiveRateValue extends React.PureComponent<Props> {
    render(): string | null {
        const { effectiveRate } = this.props;

        if (!effectiveRate) {
            return null;
        }

        return toDollars(effectiveRate);
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    effectiveRate: makeSelectMyTimesheetEffectiveRate()
});

export default connect(mapStateToProps)(MyTimesheetEntryEffectiveRateValue);
